import { render, staticRenderFns } from "./IsHelpForProtectionMeasureNeededQuestion.vue?vue&type=template&id=9c790d54&scoped=true"
import script from "./IsHelpForProtectionMeasureNeededQuestion.vue?vue&type=script&lang=ts"
export * from "./IsHelpForProtectionMeasureNeededQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c790d54",
  null
  
)

export default component.exports